const styleJS = {
    setup: {
        sectionHeader: `mt-6 text-[#29382A] font-[500]`,
    },
    details: {
        editActionButton: `float-right py-[16px] px-[24px] rounded-lg border-solid border-[1px] border-[#A0BDA2] hover:bg-[#A0BDA208] text-[13px] text-gray-700 font-[500]`,
    }
}

export default styleJS;